import { StorageSchema } from "@/shared/config";

export const storage = {
  setItem<K extends keyof StorageSchema>(key: K, value: StorageSchema[K]) {
    try {
      const serialized = JSON.stringify(value);
      localStorage.setItem(key, serialized);
    } catch (e) {
      console.error(`Error setting localStorage key "${key}":`, e);
    }
  },

  getItem<K extends keyof StorageSchema>(key: K): StorageSchema[K] | null {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as StorageSchema[K]) : null;
    } catch (e) {
      console.error(`Error getting localStorage key "${key}":`, e);
      return null;
    }
  },

  removeItem(key: keyof StorageSchema) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error(`Error removing localStorage key "${key}":`, e);
    }
  },
};
